export default {"src":"/_next/static/media/edit-icon.d6a1e70b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};